import { Typography } from 'antd';
import { SwapOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

/** 借还管理页面（占位，后续需求实现） */
export default function BorrowPage() {
  return (
    <div>
      <Title level={3}>
        <SwapOutlined /> 借还管理
      </Title>
      <Text type="secondary">借还流程功能将在后续需求中实现。</Text>
    </div>
  );
}
